import { LoginActions } from '../actions/login';
import { OtpResponse } from '../../api/login';
import {
    VERIFY_NUMBER,
    VERIFICATION_LOADER,
    VERIFICATION_ERROR,
    VERIFY_OTP_LOADER,
    VERIFY_OTP,
    VERIFY_OTP_ERROR,
    RESEND_OTP,
    RESET_NUMBER_ERROR,
    RESET_NUMBER,
    SET_MOBILE_NUMBER,
} from '../actions/login';

export interface OtpStatus {
    mobileNumber: string;
    otp: OtpResponse;
    pwdEnabled: boolean;
    mfaEnabled: boolean;
}

export interface MobileNumberData {
    mobileNumber: string;
    loading: boolean;
    txn_id?: string;
    errorMessage: string;
    pwdEnabled: boolean;
    mfaEnabled: boolean;
    isRegistered: boolean | string;
}

export interface OtpData {
    otp: OtpResponse;
    loading: boolean;
    errorMessage: string;
    otpVerified: boolean;
    maxTryError: string;
}

export interface LoginReducer {
    mobileNumber: MobileNumberData;
    otp: OtpData;
}

const mobileNumberInitialData: MobileNumberData = {
    mobileNumber: '',
    loading: false,
    errorMessage: '',
    pwdEnabled: false,
    mfaEnabled: false,
    isRegistered: false,
    txn_id: '',
};

const otpInitialData: OtpData = {
    otp: {
        success: false,
        message: '',
        nextOtpRequest: '',
        triggered: false,
        length: 0,
        retries: 0,
    },
    loading: false,
    errorMessage: '',
    otpVerified: false,
    maxTryError: '',
};

export const initialLoginState: LoginReducer = {
    mobileNumber: mobileNumberInitialData,
    otp: otpInitialData,
};

const loginReducer = (state = initialLoginState, action: LoginActions): LoginReducer => {
    switch (action.type) {
        case SET_MOBILE_NUMBER:
            return {
                ...state,
                mobileNumber: {
                    ...state.mobileNumber,
                    mobileNumber: action.mobileNumber,
                },
            };
        case VERIFY_NUMBER:
            const { mobileNumber, txn_id, message, error } = action.data;
            return {
                mobileNumber: {
                    ...state.mobileNumber,
                    isRegistered: (txn_id || '')?.length > 0,

                    mobileNumber,
                    loading: false,
                    txn_id,
                },
                otp: {
                    ...state.otp,
                    maxTryError: error?.message || '',
                    otp: {
                        triggered: true,
                        success: true,
                        message: message || '',
                        nextOtpRequest: '',
                    },
                },
            };
        case VERIFICATION_LOADER:
            return {
                ...state,
                mobileNumber: {
                    ...state.mobileNumber,
                    loading: true,
                },
            };
        case VERIFICATION_ERROR:
            return {
                ...state,
                mobileNumber: {
                    ...state.mobileNumber,
                    errorMessage: action.errorMessage,
                    isRegistered: false,
                    loading: false,
                },
            };
        case VERIFY_OTP_LOADER:
            return {
                ...state,
                otp: {
                    ...state.otp,
                    loading: true,
                },
            };
        case VERIFY_OTP_ERROR:
            return {
                ...state,
                otp: {
                    ...state.otp,
                    errorMessage: 'OTP mismatch',
                    loading: false,
                },
            };
        case VERIFY_OTP:
            return {
                ...state,
                otp: {
                    ...state.otp,
                    loading: false,
                    otpVerified: action.verified,
                    errorMessage: action.error,
                },
            };
        case RESEND_OTP:
            return {
                otp: {
                    ...state.otp,
                    otp: {
                        triggered: true,
                        success: true,
                        message: action.data.error?.message || '',
                        nextOtpRequest: '',
                    },
                    loading: false,
                    errorMessage: action.data.error?.message || '',
                    maxTryError: action.data.error?.message || '',
                },
                mobileNumber: {
                    ...state.mobileNumber,
                    loading: false,
                },
            };
        case RESET_NUMBER_ERROR:
            return {
                ...state,
                mobileNumber: {
                    ...state.mobileNumber,
                    errorMessage: '',
                    isRegistered: false,
                },
            };
        case RESET_NUMBER:
            return {
                otp: initialLoginState.otp,
                mobileNumber: {
                    ...initialLoginState.mobileNumber,
                    mobileNumber: state.mobileNumber.mobileNumber,
                },
            };
        default:
            return state;
    }
};

export default loginReducer;
